import type { SyntheticEvent } from 'react';

// The submit button stays a real submit button so that pressing Enter in a
// field submits the form; when annotations are required, the submission opens
// the memo dialog instead, whose confirmation submits the form for real.
// Drawers are portals: the submit event is stopped so that React does not also
// bubble it up to the form that opened the drawer.
export const memoAwareSubmitHandler =
  ({
    askMemo,
    mustAskMemo,
    submit,
  }: Readonly<{
    askMemo: () => void;
    mustAskMemo: boolean;
    submit: (event?: SyntheticEvent<HTMLFormElement>) => void;
  }>) =>
  (event?: SyntheticEvent<HTMLFormElement>) => {
    event?.stopPropagation();

    if (!mustAskMemo) {
      submit(event);

      return;
    }

    event?.preventDefault();
    askMemo();
  };
